import { useEffect, useState } from 'react'

/** Lock countdowns for the family entry PIN screens (D-16). */

export function formatSeconds(total: number): string {
  const m = Math.floor(total / 60)
  const s = total % 60
  return `${String(m)}:${String(s).padStart(2, '0')}`
}

/** Seconds left until `until` (ISO time), ticking every second; 0 when over. */
export function useCountdown(until: string | null, now: () => number = Date.now): number {
  const left =
    until === null ? 0 : Math.max(0, Math.ceil((Date.parse(until) - now()) / 1000))
  const [, setTick] = useState(0)
  useEffect(() => {
    if (until === null) return
    const id = setInterval(() => {
      setTick((t) => t + 1)
    }, 1000)
    return () => {
      clearInterval(id)
    }
  }, [until])
  return left
}
